import React, { useEffect } from "react";
import { Table, Progress  } from 'antd';
import { handleTableChange } from "../../../../utils/index";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import { 
	getEmployeePrograms, 
} from "../../../../redux/employee/employeeState";
import { Award } from "lucide-react";


const EmployeeProgressTable = ({
	recordList, 
	doSearch, 
	filters, 
}) => {


  	const columns = [
		{
	        title: `Employee`,
			width: '25%',
			dataIndex: 'employee_name',
	        key: 'employee_name',
	        render:(_, record) => <>
						<div className="font-medium">{record?.employee_name}</div>
						<div className="text-[12px] text-slate-700 dark:text-slate-200 ">{record?.emp_code}</div>
					</>
	    },
		{
			title: `Enrolled`,
			width: '15%',
			dataIndex: 'enrolled_count',
	        key: 'enrolled_count',
	        render:(enrolled_count) => <span>{enrolled_count}</span>

		},
		{
	        title: `Completed`,
			width: '10%',
			dataIndex: 'completed',
	        key: 'completed',
	        render:(completed) => <span className="text-green-600">{completed}</span>
	    },
		{
	        title: `Hours Spent`,
			width: '15%',
			dataIndex: 'hours_spent',
	        key: 'hours_spent',
	        render:(hours_spent) => <span>{hours_spent}</span>	    
		},
		{
	        title: `Certificates`,
			width: '15%',
			dataIndex: 'certificates',
	        key: 'certificates',
	        render:(certificates) => <span className="flex items-center gap-1">
										<Award className="w-4 h-4 text-yellow-600" />
										{certificates}
									</span>   
		},
		{
			title: `Progress`,
			dataIndex: 'progress', 
			width: '15%',
			key: 'progress',
			render: (value) => (
				<Progress
					percent={value}                        
					showInfo
					size="small"
					strokeColor="#10B981"                  
					trailColor="rgba(16, 185, 129, 0.2)"  
					format={(percent) => `${percent}%`}    
				/>
			),
		}

    ];
    
	useEffect(() => {
		doSearch();
	}, [doSearch]);
	
  	return (
		<HeaderComponent
			title="Employee Training Progress"
			description="Individual employee training statistics and achievements"
			bgcolor=""
		>
			<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
				<Table
					size="small"
					dataSource={recordList} 
					columns={columns} 
					rowKey={(record) => record?.emp_id}
					pagination={false}    
					onChange={handleTableChange(doSearch, filters)}
					scroll={{ x: 'max-content' }}                	
				/>
			</div>
			
		</HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.employee.employeePrograms?.data || [],
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (data) => dispatch(getEmployeePrograms(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeProgressTable);
